import { useEffect } from 'react';

import { useSharedState } from '@trello/shared-state';

import { useWorkspaceNavigationEnabled } from './useWorkspaceNavigationEnabled';
import { getWorkspaceFromPathname } from './getters/getWorkspaceFromPathname';
import {
  initialState,
  workspaceState,
  WorkspaceStateStatus,
} from './workspaceState';

let historyIndex = 0;

function getCurrentWorkspace() {
  return getWorkspaceFromPathname(window.location.pathname);
}

export function useCurrentWorkspace() {
  const workspaceNavigationEnabled = useWorkspaceNavigationEnabled();

  if (!workspaceNavigationEnabled) {
    workspaceState.setValue({
      ...initialState,
      status: WorkspaceStateStatus.DISABLED,
    });
  }

  const [state, setState] = useSharedState(workspaceState);

  useEffect(() => {
    if (!workspaceNavigationEnabled) {
      return;
    }

    async function updateWorkspaceState() {
      const idx = ++historyIndex;
      // Indicate that we are determining the workspace state
      setState({
        status: WorkspaceStateStatus.LOADING,
      });
      const newWorkspaceState = await getCurrentWorkspace();

      // Ensures that only the latest history event "wins",
      // so we don't end up with race conditions
      if (idx === historyIndex) {
        setState(newWorkspaceState);
      }
    }

    if (state?.status === WorkspaceStateStatus.INITIALIZING) {
      updateWorkspaceState();
    }

    window.addEventListener('pushstate', updateWorkspaceState);
    window.addEventListener('replacestate', updateWorkspaceState);
    window.addEventListener('popstate', updateWorkspaceState);

    return () => {
      window.removeEventListener('pushstate', updateWorkspaceState);
      window.removeEventListener('replacestate', updateWorkspaceState);
      window.removeEventListener('popstate', updateWorkspaceState);
    };
  }, [state, setState, workspaceNavigationEnabled]);

  return state;
}
